import script from "./TicketsHistoryFilter.vue?vue&type=script&setup=true&lang=js"
export * from "./TicketsHistoryFilter.vue?vue&type=script&setup=true&lang=js"

import "./TicketsHistoryFilter.vue?vue&type=style&index=0&id=6122371e&lang=scss"

const __exports__ = script;

export default __exports__